var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.79086 0 0 1.82708 0 4.08091C0 6.13611 1.49107 7.8314 3.42857 8.11514V13.4087C3.4275 13.486 3.44149 13.5627 3.46973 13.6344C3.49796 13.706 3.53988 13.7713 3.59305 13.8263C3.64622 13.8813 3.70958 13.925 3.77944 13.9548C3.8493 13.9846 3.92427 14 4 14C4.07573 14 4.1507 13.9846 4.22056 13.9548C4.29043 13.925 4.35378 13.8813 4.40695 13.8263C4.46012 13.7713 4.50204 13.706 4.53027 13.6344C4.55851 13.5627 4.5725 13.486 4.57143 13.4087V8.11514C6.50894 7.8314 8 6.13611 8 4.08091C8 1.82708 6.20914 0 4 0ZM4 1.16597C4.71029 1.16597 5.28571 1.55774 5.28571 2.04046C5.28571 2.52317 4.71029 2.91494 4 2.91494C3.28971 2.91494 2.71429 2.52317 2.71429 2.04046C2.71429 1.55774 3.28971 1.16597 4 1.16597Z",
    fill: "#0165FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.8ddba1b5.svg";
export { ForwardRef as ReactComponent };